<template>
  <div class="account-set">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="账号管理"></dg-header>
    <div class="account-set-con">
      <!-- 账号绑定 -->
      <div class="account-item">
<!--        <p class="account-item-title">账号绑定</p>-->
<!--        <div class="account-item-colum" @click="changeAccount">-->
        <div class="account-item-colum" >
          <span class="item-colum-left">账号昵称</span>
          <div class="item-colum-right">
            <span class>{{$route.query.name || '未知'}}</span>
          </div>
        </div>
      </div>
      <!-- 账号安全 -->
<!--      <div class="account-item">-->
<!--        <p class="account-item-title">账号安全</p>-->
<!--        <div class="account-item-colum" @click="changePwd">-->
<!--          <span class="item-colum-left">修改密码</span>-->
<!--          <div class="item-colum-right">-->
<!--            &lt;!&ndash; <span class="">123456789@gmail.com</span> &ndash;&gt;-->
<!--            <van-icon name="arrow"/>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 退出按钮 -->
      <button class="exit-login-btn" @click="loginOut">退出登录</button>
<!--      &lt;!&ndash; 账号绑定弹框 &ndash;&gt;-->
<!--      <van-dialog v-model="modifyAccountShow" show-cancel-button>-->
<!--        <van-field label="账号" v-model="accountNum"/>-->
<!--        <van-field label="账号密码" v-model="accountPwd"/>-->
<!--      </van-dialog>-->
<!--      &lt;!&ndash; 修改密码弹框 &ndash;&gt;-->
<!--      <van-dialog v-model="modifyPwdShow" show-cancel-button>-->
<!--        <van-field label="旧密码" v-model="oldPwd"/>-->
<!--        <van-field label="新密码" v-model="newPwd"/>-->
<!--        <van-field label="确认密码" v-model="confirmPwd"/>-->
<!--      </van-dialog>-->
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import api from '@/server'
export default {
  data() {
    return {
      value: "",
      modifyAccountShow: false, // 修改账号弹框
      modifyPwdShow: false // 修改密码弹框
    };
  },
  components: {
    DgHeader
  },
  methods: {
    // 点击修改账号
    changeAccount() {
      this.modifyAccountShow = !this.modifyAccountShow;
    },
    // 点击修改密码
    changePwd() {
      this.modifyPwdShow = !this.modifyPwdShow;
    },
    // 退出登陆
    loginOut() {
      api.loginOut({
        id: this.$route.query.id
      }).then(res=> {
        if (res.code === 200) {
          this.$toast.success('成功退出');
          localStorage.setItem('userInfo', '');
          localStorage.setItem('token', '');
          this.$store.dispatch('setCarNumber', 0);
          localStorage.setItem('carList', '');
          this.$router.push({
            name: 'personal-center'
          })
        }
      }).catch(err=> {
        console.log(err)
      })
    }
  }
};
</script>
<style lang="scss" >
.account-set-con {
  padding: 0 30px;
  padding-top: 108px;
  .account-item {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 30px;
    background: $bg02;
    border-radius: $br30;
    box-shadow: $box-shadow3;
    margin-bottom: 24px;
    .account-item-title {
      font-size: 30px;
      color: $fc03;
      height: 70px;
      width: 100%;
      line-height: 70px;
      border-bottom: 2px solid $bc04;
    }
    .account-item-colum {
      display: flex;
      align-items: center;
      height: 96px;
      width: 100%;
      .item-colum-left {
        font-size: 28px;
        color: $fc06;
      }
      .item-colum-right {
        flex: 1;
        overflow: hidden;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        > span {
          font-size: 28px;
          color: $fc09;
        }
        .van-icon {
          font-size: 42px;
          color: $bg04;
          display: inline-block;
        }
        &:active {
          .van-icon {
            color: $fc09;
          }
        }
      }
    }
  }
  // 修改弹框样式
  .van-dialog {
    width: 600px;
    border-radius: $br20;
    padding: 50px 30px 30px;
    box-sizing: border-box;
    // 中间内容部分
    .van-field{
      padding: 10px 0;
      // margin-bottom: 10px;
      display: flex;
      align-items: center;
      .van-field__label{
        max-width: 150px;
        text-align: right;
        >span{
          color: $fc06;
          font-size: 28px;
          margin-right: 20px;
        }
      }
      .van-field__control{
        background: $bg01;
        padding: 10px 30px;
        box-sizing: border-box;
        border-radius: $br50;
        color: $fc03;
        font-size: 30px;
      }
    }
    .van-cell:not(:last-child)::after{
      border-bottom: none;
    }
    // 底部按钮style
    .van-dialog__footer--buttons {
      justify-content: space-around;
      margin-top: 60px;
      .van-button {
        width: 240px;
        height: 80px;
        line-height: 80px;
        border-radius: $br50;
        color: $fc02;
        font-size: 30px;
        flex: inherit;
      }
      .van-dialog__cancel {
        background: $bg04;
      }
      .van-dialog__confirm {
        background: $bg05;
      }
    }
    .van-hairline--top::after{
      border-top-width: 0 !important;
    }
    .van-hairline--left::after {
      border-left-width: 0 !important;
    }
  }

  // 退出登陆按钮
  .exit-login-btn {
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: $btn02;
    @include resetButton();
    border-radius: $br50;
    color: $fc02;
    font-size: 28px;
    margin-top: 75px;
    &:active{
      background: $btnHover02;
    }
  }
}
</style>
